import React from 'react';

// X Divider system for gig mode chord subdivisions
export const XDivider: React.FC = () => (
  <svg 
    className="absolute inset-0 w-full h-full" 
    aria-hidden="true" 
    stroke="rgba(218,222,224,0.25)" 
    strokeWidth="1"
    data-debug-id="Level-3:GridXDivider"
  >
    <line x1="0" y1="0" x2="100%" y2="100%" />
    <line x1="100%" y1="0" x2="0" y2="100%" />
  </svg>
);

export const DiagonalDivider: React.FC = () => (
  <svg 
    className="absolute inset-0 w-full h-full" 
    aria-hidden="true" 
    stroke="rgba(218,222,224,0.25)" 
    strokeWidth="1"
    data-debug-id="Level-3:GridDiagonalDivider"
  >
    <line x1="0" y1="100%" x2="100%" y2="0" />
  </svg>
);

// Calculate geometric positioning for chord placement (incenter of triangle)
export const getIncenterPosition = (
  p1: { x: number; y: number },
  p2: { x: number; y: number },
  p3: { x: number; y: number }
): { top: string; left: string } => {
  const distance = (a: { x: number; y: number }, b: { x: number; y: number }) =>
    Math.sqrt(Math.pow(b.x - a.x, 2) + Math.pow(b.y - a.y, 2));

  const a = distance(p2, p3);
  const b = distance(p1, p3);
  const c = distance(p1, p2);

  const perimeter = a + b + c;
  if (perimeter === 0) return { top: '50%', left: '50%' };

  const incenter = {
    x: (a * p1.x + b * p2.x + c * p3.x) / perimeter,
    y: (a * p1.y + b * p2.y + c * p3.y) / perimeter,
  };

  return { top: `${incenter.y}%`, left: `${incenter.x}%` };
};
